// Copyright (c) 2023-2025 Matthias von Laer
// This file is part of Carsharing and is licensed under GNU Affero General Public License 3.0 or any later version. 

import {useEffect} from 'react'

export function useInterval(callback, delay) {
  useEffect(() => {
    const id = setInterval(callback, delay)
    return () => { clearInterval(id) }
  })
}

